import { Component, HostListener, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { GeneralService } from '../../Services/generalservice.service'

@Component({
    selector: 'app-job',
    templateUrl: './job.component.html',
    styleUrls: ['./job.component.scss']
})
export class JobComponent implements OnInit {
    arr: any;
    experienceOptions: string[] = [];
    skills: any;
    location: string = '';
    selectedExperience: string = '';
    experience: string | null = '';
    jobs: any[] = []; // Assuming the response is an array of job objects
    monthsGap: number;
    timeGap: string;
    LoginDetails: any; careerdata: any;
    specalizationdata: any; Experiencedata: any;
    CID: any; filterjobsdata: any; filterCompany: any;
    selectedCompany: string | null = null;
    CategoryName: any; SelectedDomain: string | null = null;
    Domainfilter: any;
    paginatedJobs: any[] = [];   // Jobs displayed on the current page
    currentPage: number = 1;     // Tracks the current page
    pageSize: number = 5;        // Number of jobs per page
    totalPages: number = 0;      // Total number of pages
    WorkingDomains: any; CompanyName: any;
    SelectedYear: any | null | '';
    applieddata: any; appliedPIDs: Set<any> = new Set(); // Initialize as Set
    CategoryFilter: any; CompanyFilter: any;
    Fskills: any;
    RecruiterName: any;
    matchingJobsData: any;
    matchedJobsCount: number = 0;
    regId: string = '';
    skillOptions: any[] = [];
    suggestedSkills: string[] = [];
    showSuggestions: boolean = false;
    searchTimeout: any;
   
    filteredSkills: string[] = this.skillOptions; 
    userDetails: any;
    debounceTimer: any;

    public suggestedLocations: any[] = [];
    public showLocationSuggestions: boolean = false;
    showSkillsSuggestions: boolean;
    constructor(public route: ActivatedRoute, public router: Router, private General: GeneralService) {
        this.LoginDetails = JSON.parse(localStorage.getItem('userDetails'));
        this.Fskills = this.LoginDetails?.KeySkills ?? 'undefined';
        this.CID = this.route.snapshot.paramMap.get('CID')
        if (this.CID) {
            this.CID = this.CID
        } else {
            this.CID = 1
        }
    }

    ngOnInit() {
        // First initialize experience options
        for (let i = 1; i <= 30; i++) {
            this.experienceOptions.push(`${i} ${i === 1 ? 'Year' : 'Years'}`);
        }

        // Initialize applied jobs first, then load other data
        this.appliedjob().then(() => {
            // After applied jobs are loaded, load other job data
            this.getfilterjob();
            this.careerjob();
            this.specalization();
            this.Experience();

            // Handle query params after applied jobs are loaded
            this.route.queryParams.subscribe(params => {
                this.skills = params['skills'] || '';
                this.location = params['location'] || '';
                this.selectedExperience = params['experience'] || '';
                this.findJobs()
            });

            const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
            if (userDetails?.RegId) {
                this.regId = userDetails.RegId;
                this.getJobsByMatchingSkills(this.regId);
            }
        });
    }

    getJobsByMatchingSkills(regId: string) {
        const uploadfile = new FormData();
        uploadfile.append('Param1', regId);

        const url = "api/Njobs/Get_Matching_Jobs_By_Skills";

        this.General.PostData(url, uploadfile).then((response: any) => {
            if (response?.Success && response.Jobs?.length > 0) {
                // Filter out already applied jobs immediately
                if (this.LoginDetails && this.appliedPIDs && this.appliedPIDs.size > 0) {
                    this.matchingJobsData = response.Jobs.filter(job => !this.appliedPIDs.has(job.PID));
                    console.log('Matching jobs after filtering applied ones:', this.matchingJobsData.length); // Debug log
                } else {
                    this.matchingJobsData = response.Jobs;
                }

                this.matchedJobsCount = this.matchingJobsData.length; // Update count after filtering

                if (this.matchingJobsData.length > 0) {
                    this.totalPages = Math.ceil(this.matchingJobsData.length / this.pageSize);
                    this.updatecompany();
                } else {
                    this.totalPages = 0;
                }
            } else {
                this.matchingJobsData = [];
                this.matchedJobsCount = 0;
                this.totalPages = 0;
            }
        }).catch(error => {
            console.error("Error fetching matching jobs:", error);
        });
    }

    findJobs() {
        debugger
        //if (!this.LoginDetails) {
        //    // Navigate to /job page without running the search if user is not logged in
        //    this.router.navigate(['/job']);
        //    return;
        //}
        const UploadFile = new FormData();
        UploadFile.append("Param1", this.skills);
        UploadFile.append("Param2", this.location);
        UploadFile.append("Param3", this.selectedExperience);

        //const url = "api/Njobs/Search_Jobs";
        const url = "api/Njobs/SkillsSearchDropdown";

        this.General.PostData(url, UploadFile).then((data: any) => {
            this.matchingJobsData = data || [];
            this.jobs = this.matchingJobsData;
            this.router.navigate(['/job'], {
                state: {
                   // jobResults: this.matchingJobsData, // Pass results directly
                    skills: this.skills,              // Pass search term for display/logging
                    location: this.location,
                    experience: this.selectedExperience
                }
            });
            //if (this.matchingJobsData.length > 0) {
            //    this.totalPages = Math.ceil(this.jobs.length / this.pageSize);
            //    this.updatePaginatedJobs();

            //    const lastJobDate = new Date(this.jobs[this.jobs.length - 1].CreatedDate);
            //    const currentDate = new Date();
            //    const monthDiff = this.calculateMonthDifference(lastJobDate, currentDate);

            //    if (monthDiff > 0) {
            //        this.timeGap = `${monthDiff} Month(s)`;
            //    } else {
            //        const dayDiff = this.calculateDayDifference(lastJobDate, currentDate);
            //        if (dayDiff > 0) {
            //            this.timeGap = `${dayDiff} Day(s)`;
            //        } else {
            //            this.timeGap = this.calculateTimeDifference(lastJobDate, currentDate);
            //        }
            //    }
            //} else {
            //    this.timeGap = 'No jobs found';
            //}
        }).catch((error) => {
            console.error("Error fetching jobs", error);
        });
    }

    // Fetch applied jobs and return promise to ensure data is loaded
    appliedjob(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (!this.LoginDetails) {
                // User is not logged in, resolve immediately
                this.appliedPIDs = new Set(); // Initialize empty set
                resolve();
                return;
            }

            const seekerID = this.LoginDetails.RegId;
            var uploadfile = new FormData();
            uploadfile.append("SeekerID", seekerID);

            var url = "api/Njobs/Get_Seekar_AppliedJobs";
            this.General.PostData(url, uploadfile).then(data => {
                this.applieddata = data || [];
                // Store applied PIDs in a set
                this.appliedPIDs = new Set(this.applieddata.map(job => job.PID));
                console.log('Applied PIDs loaded:', this.appliedPIDs); // Debug log
                resolve();
            }).catch(error => {
                console.error("Error fetching applied jobs:", error);
                this.appliedPIDs = new Set(); // Initialize empty set on error
                reject(error);
            });
        });
    }

    // Helper function to calculate month difference
    private calculateMonthDifference(lastDate: Date, currentDate: Date): number {
        return (currentDate.getFullYear() - lastDate.getFullYear()) * 12 + (currentDate.getMonth() - lastDate.getMonth());
    }

    // Helper function to calculate day difference
    private calculateDayDifference(lastDate: Date, currentDate: Date): number {
        const diffTime = Math.abs(currentDate.getTime() - lastDate.getTime());
        return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    }

    // Helper function to calculate time difference in hours and minutes
    private calculateTimeDifference(lastDate: Date, currentDate: Date): string {
        const diffTime = Math.abs(currentDate.getTime() - lastDate.getTime());
        const hours = Math.floor(diffTime / (1000 * 60 * 60));
        const minutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
        return `${hours} hr(s), ${minutes} min(s)`;
    }

    // Helper function to update the displayed jobs based on the current page
    updatePaginatedJobs() {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;

        if (!this.LoginDetails) {
            // For non-logged in users, show all jobs
            this.paginatedJobs = this.jobs.slice(startIndex, endIndex);
            return;
        } else if (this.LoginDetails) {
            // Extract the first skill from this.Fskills
            const cskill = this.Fskills
            const firstSkill = cskill.split(',')[0].trim();

            // Filter jobs based on the first skill (jobs array is already filtered for applied jobs)
            const filteredJobs = this.jobs.filter(item => {
                const matchesSkill = item.RequiredSkills.split(',')[0].trim().toLowerCase() === firstSkill.toLowerCase();
                return matchesSkill; // Applied jobs are already removed from this.jobs
            });

            // Recalculate total pages based on filtered jobs
            this.totalPages = Math.ceil(filteredJobs.length / this.pageSize);

            // Apply pagination to the filtered jobs
            this.paginatedJobs = filteredJobs.slice(startIndex, endIndex);
            return;
        }
    }

    // Navigate to the next page
    nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.updatePaginatedJobs();
            this.updatecategory();
        }
    }

    // Navigate to the previous page
    previousPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.updatePaginatedJobs();
            this.updatecategory();
        }
    }

    updatecategory() {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;

        // Since filterjobsdata is already filtered, just paginate
        this.CategoryFilter = this.filterjobsdata.slice(startIndex, endIndex);
    }

    compantnextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.updatecompany();
        }
    }

    companyPrevious() {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.updatecompany();
        }
    }

    updatecompany() {
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;

        // Since matchingJobsData is already filtered, just paginate
        this.CompanyFilter = this.matchingJobsData.slice(startIndex, endIndex);
    }

    //filter button
    isFilterActive = false;

    toggleFilter(): void {
        this.isFilterActive = !this.isFilterActive;
    }

    closeFilter(): void {
        this.isFilterActive = false;
    }

    @HostListener('document:keydown.escape')
    onEscapePress() {
        this.closeFilter();
    }

    // IMPROVED: After applying job - hide the job from display
    applujob(job: any) {
        if (!this.LoginDetails) {
            this.General.ShowAlert("Alert", 'You are not logged in. Please log in to apply for jobs.', 'Alert');
            this.router.navigate(['/Login']);
            return;
        }

        if (this.LoginDetails.ApprovalStatus === 1) {
            this.General.ShowAlert("ERROR", 'You do not have permission to apply for jobs. Admin approval is required.', 'error');
            return;
        }

        // Apply for job logic
        this.arr = [{
            SeekerID: this.LoginDetails.RegId,
            P_ID: job.PID,
            R_ID: job.RID,
            ActionStatus: 1,
            AppliedStatus: 1
        }];

        var uploadfile = new FormData();
        uploadfile.append("xml", JSON.stringify(this.arr));

        var url = "api/Njobs/Insert_Applied_Job";
        this.General.PostData(url, uploadfile).then(data => {
            if (data === "SUCCESS") {
                // IMPROVED: Add the job PID to applied jobs immediately
                this.appliedPIDs.add(job.PID);

                // IMPROVED: Remove the applied job from all current displays
                this.removeAppliedJobFromDisplays(job.PID);

                // IMPROVED: Refresh applied jobs data to ensure consistency
                this.refreshAppliedJobs();

                this.General.ShowAlert("SUCCESS", 'You have successfully applied for this job.', 'success');
                this.router.navigate(['/appliedjobs']);
            } else {
                this.General.ShowAlert("ERROR", 'Something went wrong. Please try again later.', 'error');
            }
        }).catch(error => {
            console.error("Error applying for job:", error);
            this.General.ShowAlert("ERROR", 'Something went wrong. Please try again later.', 'error');
        });
    }

    // NEW: Method to remove applied job from all current displays
    private removeAppliedJobFromDisplays(appliedPID: any) {
        // Remove from paginatedJobs
        this.paginatedJobs = this.paginatedJobs.filter(job => job.PID !== appliedPID);

        // Remove from matchingJobsData
        if (this.matchingJobsData) {
            this.matchingJobsData = this.matchingJobsData.filter(job => job.PID !== appliedPID);
            this.matchedJobsCount = this.matchingJobsData.length;
        }

        // Remove from CategoryFilter
        if (this.CategoryFilter) {
            this.CategoryFilter = this.CategoryFilter.filter(job => job.PID !== appliedPID);
        }

        // Remove from CompanyFilter
        if (this.CompanyFilter) {
            this.CompanyFilter = this.CompanyFilter.filter(job => job.PID !== appliedPID);
        }

        // Remove from filterCompany
        if (this.filterCompany) {
            this.filterCompany = this.filterCompany.filter(job => job.PID !== appliedPID);
        }

        // Remove from main jobs array
        this.jobs = this.jobs.filter(job => job.PID !== appliedPID);

        // Remove from filterjobsdata
        if (this.filterjobsdata) {
            this.filterjobsdata = this.filterjobsdata.filter(job => job.PID !== appliedPID);
        }

        // Recalculate pagination after removal
        this.recalculatePagination();
    }

    // NEW: Method to recalculate pagination after job removal
    private recalculatePagination() {
        // Determine which dataset to use for pagination calculation
        let dataLength = 0;

        if (this.matchingJobsData && this.matchingJobsData.length > 0) {
            dataLength = this.matchingJobsData.length;
        } else if (this.filterjobsdata && this.filterjobsdata.length > 0) {
            dataLength = this.filterjobsdata.length;
        } else {
            dataLength = this.jobs.length;
        }

        this.totalPages = Math.ceil(dataLength / this.pageSize);

        // If current page becomes empty, go to previous page
        if (this.currentPage > this.totalPages && this.totalPages > 0) {
            this.currentPage = this.totalPages;
        }

        // If no pages left, reset to page 1
        if (this.totalPages === 0) {
            this.currentPage = 1;
        }
    }

    // IMPROVED: Method to refresh applied jobs data
    private refreshAppliedJobs(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (!this.LoginDetails) {
                resolve();
                return;
            }

            const seekerID = this.LoginDetails.RegId;
            const uploadfile = new FormData();
            uploadfile.append("SeekerID", seekerID);

            const url = "api/Njobs/Get_Seekar_AppliedJobs";
            this.General.PostData(url, uploadfile).then(data => {
                this.applieddata = data;
                this.appliedPIDs = new Set(this.applieddata.map(job => job.PID));
                resolve();
            }).catch(error => {
                console.error("Error refreshing applied jobs:", error);
                reject(error);
            });
        });
    }

    careerjob() {
        var uploadfile = new FormData();
        uploadfile.append("Param", '1');
        var url = "api/Njobs/Get_Jobs_Specialization";
        this.General.PostData(url, uploadfile).then(data => {
            this.careerdata = data;
        })
    }

    specalization() {
        var uploadfile = new FormData();
        uploadfile.append("Param", '2');
        var url = "api/Njobs/Get_Jobs_Specialization";
        this.General.PostData(url, uploadfile).then(data => {
            this.specalizationdata = data
        })
    }

    Experience() {
        var uploadfile = new FormData();
        uploadfile.append("Param", '3');
        var url = "api/Njobs/Get_Jobs_Specialization";
        this.General.PostData(url, uploadfile).then(data => {
            this.Experiencedata = data;
        })
    }

    //categories can get
    getfilterjob() {
        var uploadfile = new FormData();
        uploadfile.append('Param1', this.CID);
        var url = "api/Njobs/Get_Category_Jobs_Filter";
        this.General.PostData(url, uploadfile).then((data: any) => {
            // Filter out applied jobs for logged-in users immediately
            if (this.LoginDetails && this.appliedPIDs && this.appliedPIDs.size > 0) {
                this.filterjobsdata = data.filter(job => !this.appliedPIDs.has(job.PID));
                console.log('Category jobs after filtering applied ones:', this.filterjobsdata.length); // Debug log
            } else {
                this.filterjobsdata = data;
            }

            this.CategoryName = this.filterjobsdata[0]?.CategoryName;
            if (this.filterjobsdata.length > 0) {
                this.totalPages = Math.ceil(this.filterjobsdata.length / this.pageSize);
                this.updatecategory();
            } else {
                this.totalPages = 0;
            }
        }).catch(error => {
            console.error("Error fetching category jobs:", error);
        });
    }

    //filter by Company Names
    Companyfilter(CompanyName) {
        var uploadfile = new FormData();
        uploadfile.append('Param1', CompanyName);
        uploadfile.append('Param2', this.SelectedDomain || '');
        uploadfile.append('Param3', this.SelectedYear || '');
        var url = "api/Njobs/Get_jobs_BasedOn_CompanyName";
        this.General.PostData(url, uploadfile).then((data: any) => {
            // Filter out applied jobs immediately
            if (this.LoginDetails && this.appliedPIDs && this.appliedPIDs.size > 0) {
                this.matchingJobsData = data.filter(job => !this.appliedPIDs.has(job.PID));
                console.log('Company filtered jobs after filtering applied ones:', this.matchingJobsData.length); // Debug log
            } else {
                this.matchingJobsData = data;
            }

            this.CompanyName = this.matchingJobsData[0]?.CompanyName;
            if (this.matchingJobsData && this.matchingJobsData.length > 0) {
                this.totalPages = Math.ceil(this.matchingJobsData.length / this.pageSize);
                this.updatecompany();
            } else {
                this.totalPages = 0;
            }
        }).catch(error => {
            console.error("Error fetching company filtered jobs:", error);
        });
    }

    onCompanySelect(RecruiterName: string) {
        // Toggle the selected company
        if (this.selectedCompany === RecruiterName) {
            this.selectedCompany = null;
            this.matchingJobsData = null;
        } else {
            this.selectedCompany = RecruiterName;
            this.Companyfilter(RecruiterName);
        }
    }

    onSelectWorking(domain: string) {
        if (this.SelectedDomain === domain) {
            this.SelectedDomain = null;
        } else {
            this.SelectedDomain = domain;
            this.Companyfilter(this.selectedCompany);
        }
    }

    onSelectedyear(Year: string) {
        if (this.SelectedYear === Year) {
            this.SelectedYear = null;
        } else {
            this.SelectedYear = Year;
            this.Companyfilter(this.selectedCompany);
        }
    }

    domainfilter(Domain) {
        var uploadfile = new FormData();
        uploadfile.append('Param1', Domain);
        var url = "api/Njobs/Get_Jobson_workingdomain";
        this.General.PostData(url, uploadfile).then(data => {
            this.Domainfilter = data;
            this.WorkingDomains = this.Domainfilter[0]?.WorkingDomains;
        })
    }

    //routing by after login candidate only can submit his resume 
    uploadresume() {
        if (!this.LoginDetails) {
            this.router.navigate(['/Login']);
        } else {
            this.router.navigate(['/useraccount']);
        }
    }



    //searchSkills() {
    //    clearTimeout(this.searchTimeout);

    //    // Minimum length check to avoid flooding the API
    //    if (!this.skills || this.skills.length < 2) {
    //        this.suggestedSkills = [];
    //        this.showSuggestions = false;
    //        return;
    //    }

    //    // Debounce: Wait 300ms before calling the API
    //    this.searchTimeout = setTimeout(() => {
    //        this.fetchSkillsFromApi(this.skills);
    //    }, 300);
    //}

    ///**
    // * Sends API call to fetch suggested skills (GetSkillsForDropdown).
    // */
    //fetchSkillsFromApi(searchTerm: string) {
    //    // NOTE: This uses the new GET endpoint implemented in the API layer
    //    const url = "api/Njobs/GetSkillsForDropdown?searchTerm=" + searchTerm;

    //    // Use your General service's GET method
    //    this.General.GetData(url).then((data: any) => {
    //        // Assuming your API returns: { success: true, skills: ["java", "javascript", ...] }
    //        if (data && data.success && data.skills && data.skills.length > 0) {
    //            this.suggestedSkills = data.skills;
    //            this.showSuggestions = true;
    //        } else {
    //            this.suggestedSkills = [];
    //            this.showSuggestions = false;
    //        }
    //    }).catch((error) => {
    //        console.error("Error fetching skill suggestions", error);
    //        this.suggestedSkills = [];
    //        this.showSuggestions = false;
    //    });
    //}

    ///**
    // * Handles selection of a skill from the autocomplete dropdown.
    // */
    //selectSkill(skill: string) {
    //    this.skills = skill;
    //    // Hide the suggestion dropdown immediately after selection
    //    this.suggestedSkills = [];
    //    this.showSuggestions = false;
    //    // Optional: You could trigger findJobs() here if desired
    //    // this.findJobs();
    //}


    // 1. Debounced input change handler
    onSearchInputChange(fieldName: string, value: string): void {
        if (fieldName !== 'skills') {
            return;
        }

        // Clear previous timer to prevent excessive API calls
        clearTimeout(this.debounceTimer);
        this.skills = value; // Update the model (ngModel)

        if (!value || value.trim().length === 0) {
            this.suggestedSkills = [];
            this.showSuggestions = false;
            return;
        }

        // Set a new timer.
        this.debounceTimer = setTimeout(() => {
            this.fetchSkills(value.trim());
        }, 300);
    }

    // 2. API call to fetch suggested skills
    async fetchSkills(searchTerm: string): Promise<void> {
        const url = 'api/Njobs/GetSkillsForDropdown';

        try {
            const fullUrl = `${url}?searchTerm=${encodeURIComponent(searchTerm)}`;

            // Assuming this.General.GetData is available and handles GET requests
            const response: any = await this.General.GetData(fullUrl);

            if (response && response.success === true && Array.isArray(response.skills)) {
                this.suggestedSkills = response.skills;
                this.showSuggestions = this.suggestedSkills.length > 0;
            } else {
                this.suggestedSkills = [];
                this.showSuggestions = false;
            }

        } catch (error) {
            console.error("Error fetching skill suggestions:", error);
            this.suggestedSkills = [];
            this.showSuggestions = false;
        }
    }

    // 3. Selection handler
    selectSkill(skillName: string): void {
        this.skills = skillName;
        this.suggestedSkills = [];
        this.showSuggestions = false;
    }


    // 1. UPDATED: onSearchInputChange Method
    // This method handles both 'skills' and 'location' inputs.
    onSearchInputChange1(fieldName: 'skills' | 'location', value: string): void {

        clearTimeout(this.debounceTimer);

        // Update ngModel and manage visibility for both dropdowns
        if (fieldName === 'skills') {
            this.skills = value;
            this.showLocationSuggestions = false; // Hide location dropdown when typing skills
        } else if (fieldName === 'location') {
            this.location = value;
            this.showSkillsSuggestions = false; // Hide skills dropdown when typing location
        }

        if (!value || value.trim().length < 1) {
            this.suggestedLocations = [];
            this.showLocationSuggestions = false;
            // Keep suggestedSkills clear if needed, but primary focus is clearing location
            return;
        }

        // Debounce the fetch call
        this.debounceTimer = setTimeout(() => {
            if (fieldName === 'location') {
                this.fetchLocations(value.trim());
            }
            // Logic for skills search should be handled in an 'else if' block for fieldName === 'skills'
        }, 300);
    }

    // 2. NEW: fetchLocations Method
    async fetchLocations(searchTerm: string): Promise<void> {
        const url = 'api/Njobs/GetLocationsForDropdown';

        try {
            const fullUrl = `${url}?searchTerm=${encodeURIComponent(searchTerm)}`;

            // Use the General service to make the GET request
            const response: any = await this.General.GetData(fullUrl);

            // IMPORTANT: The Controller returns the list under the key 'skills', so we access response.skills
            if (response && response.success === true && Array.isArray(response.skills)) {
                this.suggestedLocations = response.skills;
                this.showLocationSuggestions = this.suggestedLocations.length > 0;
            } else {
                this.suggestedLocations = [];
                this.showLocationSuggestions = false;
            }

        } catch (error) {
            console.error("Error fetching location suggestions:", error);
            this.suggestedLocations = [];
            this.showLocationSuggestions = false;
        }
    }

    // 3. NEW: selectLocation Method
    selectLocation(locationName: string): void {
        this.location = locationName; // Set the input field value
        this.suggestedLocations = []; // Clear suggestions
        this.showLocationSuggestions = false; // Hide the dropdown
    }
}
